import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { submitManualEntry } from '../../services/guardService';
import '../../styles/ManualEntry.css';

export default function ManualEntryForm() {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const onSubmit = async (data) => {
    setError('');
    try {
      const res = await submitManualEntry(data);
      if (res.success) {
        setResult({ success: true, name: data.fullName });
      }
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erreur lors de l\'enregistrement');
    }
  };

  if (result) {
    return (
      <div className="manual-entry-page">
        <div className="manual-entry-success">
          <div className="success-icon">✓</div>
          <h2>Entrée enregistrée</h2>
          <p>{result.name} a été enregistré(e) avec succès.</p>
          <div className="manual-actions">
            <button className="btn btn-primary" onClick={() => navigate('/guard')} style={{ minHeight: '80px' }}>
              Retour au scan
            </button>
            <button className="btn btn-secondary" onClick={() => { setResult(null); setError(''); }} style={{ minHeight: '80px' }}>
              Nouvelle entrée manuelle
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="manual-entry-page">
      <div className="manual-entry-container">
        <h1>Entrée manuelle</h1>
        <p>Enregistrer un visiteur sans code QR</p>

        {error && <div className="error-banner">{error}</div>}

        <form onSubmit={handleSubmit(onSubmit)} className="manual-entry-form">
          <div className="form-group">
            <label>Nom complet *</label>
            <input
              {...register('fullName', { required: 'Le nom est requis' })}
              placeholder="Nom du visiteur"
            />
            {errors.fullName && <span className="field-error">{errors.fullName.message}</span>}
          </div>

          <div className="form-group">
            <label>Motif de la visite *</label>
            <input
              {...register('reason', { required: 'Le motif est requis' })}
              placeholder="Motif de la visite"
            />
            {errors.reason && <span className="field-error">{errors.reason.message}</span>}
          </div>

          <div className="form-group">
            <label>Remarques</label>
            <textarea
              {...register('notes')}
              placeholder="Remarques supplémentaires (optionnel)"
              rows={3}
            />
          </div>

          <div className="form-actions">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
              style={{ minHeight: '80px' }}
            >
              {isSubmitting ? 'Enregistrement...' : 'Enregistrer l\'entrée'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate('/guard')}
              style={{ minHeight: '80px' }}
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
